<ng-container [ngSwitch]="screen">
    <cm-fees-initial-screen
        *ngSwitchCase="FeesScreens.Initial"
        [step]="step"
        [workflowTypeId]="workflowTypeId"
        [isPreviousPaymentPage]="isPreviousPaymentPage"
        [voucherValue]="voucherValue"
        (toggleMode)="toggleMode.emit()"
        (switchScreen)="onSwitchScreen($event)"
        (closeModal)="activeModal.close()"
        (dismissModal)="activeModal.dismiss()"
        (changeVoucherValue)="confirmVoucherValueChange($event)"
    >
    </cm-fees-initial-screen>
    <cm-fees-payment-screen
        *ngSwitchCase="FeesScreens.Payment"
        [step]="step"
        (back)="onBackFromPayment()"
        (toggleMode)="toggleMode.emit()"
        (closeModal)="activeModal.close()"
        (dismissModal)="activeModal.dismiss()"
    >
    </cm-fees-payment-screen>
    <cm-fees-file-upload-screen
        *ngSwitchCase="FeesScreens.FileUpload"
        [step]="step"
        (switchScreen)="onSwitchScreen($event)"
        (toggleMode)="toggleMode.emit()"
        (closeModal)="activeModal.close()"
        (dismissModal)="activeModal.dismiss()"
    >
    </cm-fees-file-upload-screen>
    <cm-fees-third-party-screen
        *ngSwitchCase="FeesScreens.ThirdParty"
        [step]="step"
        (toggleMode)="toggleMode.emit()"
        (switchScreen)="onSwitchScreen($event)"
        (closeModal)="activeModal.close()"
        (dismissModal)="activeModal.dismiss()"
    >
    </cm-fees-third-party-screen>
    <cm-reset-confirm-content
        *ngSwitchCase="FeesScreens.ResetConfirm"
        (cancel)="goToInitialPage()"
        (confirm)="onResetConfirm()"
    >
    </cm-reset-confirm-content>
    <cm-voucher-confirm-screen
        *ngSwitchCase="FeesScreens.VoucherConfirm"
        [voucherValue]="voucherValue"
        [step]="step"
        (back)="onBackFromPayment()"
        (dismissModal)="activeModal.dismiss()"
        (cancel)="activeModal.close()"
    >
    </cm-voucher-confirm-screen>
</ng-container>
